import directives from '@directives'

export default [].concat(directives)
